"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostgresParameterOrgProvidedInputKeyConfigs = void 0;
const validatePostgresParameterOrgProvidedInputKeyConfigs = (params) => {
    const { configs, keys } = params;
    const errors = [];
    const keySet = new Set(keys);
    configs.forEach((config) => {
        const { key } = config;
        if (!keySet.has(key)) {
            errors.push(`Postgres parameter org provided input key config contains invalid key: ${key}. Valid keys: ${JSON.stringify(keys)}`);
        }
    });
    return { errors };
};
exports.validatePostgresParameterOrgProvidedInputKeyConfigs = validatePostgresParameterOrgProvidedInputKeyConfigs;
//# sourceMappingURL=postgresParameterOrgProvidedInputKeyConfigs.js.map